import PropTypes from 'prop-types';
import React from 'react';

const InfoCircleSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 14.6666C11.6663 14.6666 14.6663 11.6666 14.6663 7.99998C14.6663 4.33331 11.6663 1.33331 7.99967 1.33331C4.33301 1.33331 1.33301 4.33331 1.33301 7.99998C1.33301 11.6666 4.33301 14.6666 7.99967 14.6666Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 7.33331V10.6666" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.99609 5.33331H8.00208" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

InfoCircleSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default InfoCircleSvg;
